import React from 'react';
import { type Components, TinaMarkdown } from 'tinacms/dist/rich-text';
import type { ExtractProps } from '@/utils/props';
import { MarkdownButton } from '@/app/(base)/components/markdown/markdown-button';
import { MarkdownImage } from '@/app/(base)/components/markdown/markdown-image';
import { MarkdownLink } from '@/app/(base)/components/markdown/markdown-link';
import { MarkdownMark } from '@/app/(base)/components/markdown/markdown-mark';
import { MarkdownDonate } from '@/app/(base)/components/markdown/markdown-donate';

type ComponentsList = Components<{
  Button: ExtractProps<typeof MarkdownButton>;
  Image: ExtractProps<typeof MarkdownImage>;
  Mark: ExtractProps<typeof MarkdownMark>;
  Donate: ExtractProps<typeof MarkdownDonate>;
  a: ExtractProps<typeof MarkdownLink>;
}>;

const components = {
  Button: MarkdownButton,
  Image: MarkdownImage,
  Mark: MarkdownMark,
  Donate: MarkdownDonate,
  a: MarkdownLink,
} as ComponentsList;

export function MarkdownText(
  props: ExtractProps<typeof TinaMarkdown>,
): React.JSX.Element {
  return <TinaMarkdown {...props} components={components} />;
}
